import React, {Component} from 'react';
import axios from 'axios';
import { Card, CardBody } from 'reactstrap';
import {FaShoppingCart, FaCreditCard} from "react-icons/fa";
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import {Link} from "react-router-dom";
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";

class DetailOrderComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            error: false,
            messageError: '',
            btnSubmit: true,
            order: {},
            isNotification: false,
            textNotification: '',
        }
    }

    componentDidMount() {
        document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        window.scrollTo(0, 0);
        this.getDetailOrder(this.props.orderId);

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
            errorNotification: this.props.errorNotificationUser,
            messageErrorNotification: this.props.messageErrorNotificationUser,
            successNotification: this.props.successNotificationUser,
            messageSuccessNotification: this.props.messageSuccessNotificationUser,
        })
        if (this.props.isNotification) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }

        if (this.props.errorNotificationUser) {
            this.props.updateErrorNotiUser({
                error: false,
                message: ''
            });
        }
        if (this.props.successNotificationUser) {
            this.props.updateSuccessNotiUser({
                success: false,
                message: ''
            });
        }
    }
  
    getDetailOrder = (orderId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/order/getDetailOrder/' + orderId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        order: ref.data.order,
                        loadPage: false,
                        isLoading: false,
                    })
                    let item = {
                        credit: ref.data.credit
                    }
                    this.props.updateCredit(item);
                } else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 7999 ) {
                        this.redirect();
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn đặt hàng thất bại',
                })
            })
    }

    loadDetailOrder = () => {
        if ( this.state.error ) {
            return (
                <Alert color="danger">
                    { this.state.messageError }
                </Alert>
            )
        }
        else {
            if ( Object.keys(this.state.order).length ) {
                return (
                    <div className="detail-order-page">
                        <div className="detail-order p-3 mb-3">
                            <div className="row invoice-header">
                                <div className="col-md-6 logo">
                                    <img src={ this.props.config.website_logo } alt="cloudzone.vn" style={{ 'maxWidth': 200, 'maxHeight': 100 }} />
                                    <p className="invoice-code">Hóa đơn #{ this.state.order.ma_gd }</p>
                                </div>
                                <div className="col-md-6 invoice-status text-center">
                                    {
                                        this.state.order.status === 'Pending' || this.state.order.status === 'Cancel' ? (
                                            <>
                                                <div className="unpaid">{ this.state.order.text_status }</div>
                                                <div className="due-create">Ngày kết thúc { this.state.order.text_end_date }</div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="paid">{ this.state.order.text_status }</div>
                                                <div className="due-create">Ngày tạo { this.state.order.text_create_date }</div>
                                                <div className="due-create">Ngày thanh toán { this.state.order.text_payment_date }</div>
                                            </>
                                        )
                                    }
                                </div>
                                <hr/>
                                <div className="col-md-12 invoice-info">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <strong className="invoice-info-header">
                                                Nhà cung cấp dịch vụ
                                            </strong>
                                            <address>
                                                { this.props.config.website_company }<br />
                                                { this.props.config.website_address }<br />
                                                SĐT: { this.props.config.website_phone }<br />
                                                Email: { this.props.config.website_email }
                                            </address>
                                        </div>
                                        <div className="col-sm-6 text-right">
                                            <strong className="invoice-info-header">
                                                Thông tin khách hàng
                                            </strong>
                                            <address>
                                                { this.props.user.name } <br/>
                                                { this.props.user.address } <br/>
                                                SĐT: { this.props.user.phone } <br/>
                                                Email: { this.props.user.email }
                                            </address>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <table className="table-striped table table-bordered">
                                        <thead>
                                            <tr>
                                                <th width="60%">Mô tả chi tiết</th>
                                                <th className="text-center">Thời gian</th>
                                                <th className="text-center">Số tiền</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { this.loadServiceOrder() }
                                        </tbody>
                                    </table>
                                </div>
                                {
                                    this.state.order.status === 'Pending' ? (
                                        <div className="invoice-paid col-md-12">
                                            <div className="payment-method row">
                                                <div className="col-md-6 col-lg-6" />
                                                <div className="col-md-6 col-lg-6">
                                                    <p className="lead">
                                                        Ngày kết thúc: { this.state.order.text_end_date }
                                                    </p>
                                                    <div className="table-responsive">
                                                        <table className="table">
                                                            <tbody>
                                                            <tr>
                                                                <td>Thành tiền</td>
                                                                <td>{ this.state.order.text_total } ₫</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Số dư tài khoản</td>
                                                                <td>{ this.addCommas(this.props.credit) } ₫</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-3 float-right">
                                                {
                                                    this.props.credit >= this.state.order.total ? (
                                                        <Link to={'/thanh-toan/' + this.state.order.id + '/thanh-toan-don-hang.html'}  className="btn btn-success m-1">
                                                            <FaCreditCard /> Thanh toán
                                                        </Link>
                                                    ) : (
                                                        <Link to={'/nap-tien-tai-khoan.html'}  className="btn btn-danger m-1">Nạp tiền tài khoản</Link>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    loadServiceOrder = () => {
        return (
            <>
                {
                    this.state.order.listInfoOrder.map( (infoOrder, key) => (
                        <tr key={key}>
                            <td>
                                { infoOrder.text_info }<br/>
                                { infoOrder.textConfigVps }
                            </td>
                            <td className="text-right">{ infoOrder.text_time }</td>
                            <td className="text-center">{ infoOrder.amount } ₫</td>
                        </tr>
                    ))
                }
                <tr>
                    <td className="text-right font-weight-bold" colSpan={2}>Số lượng</td>
                    <td className="text-center">{ this.state.order.quantity }</td>
                </tr>
                <tr>
                    <td className="text-right font-weight-bold" colSpan={2}>Thành tiền</td>
                    <td className="text-center">{ this.state.order.text_total } ₫</td>
                </tr>
            </>
        )
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <>
                    <Alert color="success">
                        { this.state.textNotification }
                    </Alert>
                </>
            );
        }
        if ( this.state.errorNotification ) {
            return (
                <>
                    <Alert color="danger">
                        { this.state.messageErrorNotification }
                    </Alert>
                </>
            );
        }
        if ( this.state.successNotification ) {
            return (
                <>
                    <Alert color="success">
                        { this.state.messageSuccessNotification }
                    </Alert>
                </>
            );
        }
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    redirect = () => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Đơn hàng không tồn tại hoặc không thuộc quyền quản lý của quý khách. Quý khách vui lòng kiểm tra lại'
        });
        this.props.shouldRedirect();
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Chi tiết đơn hàng"} page={"Đơn đặt hàng"} icon={<FaShoppingCart className="breadcrumb-icon"/>} />
                            <Card className="w-75 m-auto">
                                <CardBody>
                                    {
                                        this.checkNotification()
                                    }
                                    {
                                        this.loadDetailOrder()
                                    }
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
        config: state.configSystem.config,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerDetailOrder' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailOrderComponent);